export const pageMeta = {
  '/login': {
    title: 'AdMobilize - Login',
    description: 'Welcome to the login page of our website.',
    noIndex: true
  },
  '/forgot': {
    title: 'AdMobilize - Forgot Password',
    description: 'Reset your password here.',
    noIndex: true
  },
  '/': {
    title: 'AdMobilize - Summary',
    description: 'Overview of your analytics and data.',
    noIndex: true
  },
  '/summary': {
    title: 'AdMobilize - Summary',
    description: 'Overview of your analytics and data.',
    noIndex: true
  },
  '/charts': {
    title: 'AdMobilize - Analytics',
    description: 'Detailed analytics and reports.',
    noIndex: true
  },
  '/insights': {
    title: 'AdMobilize - Insights',
    description: 'Manage your account settings.',
    noIndex: true
  },
  '/discovery': {
    title: 'AdMobilize - Discovery',
    description: 'Discover insights from your data.',
    noIndex: true
  },
  '/sites': {
    title: 'AdMobilize - Sites',
    description: 'Manage your sites and locations.',
    noIndex: true
  },
  '/devices': {
    title: 'AdMobilize - Devices',
    description: 'Overview and management of your devices.',
    noIndex: true
  },
  '/reports': {
    title: 'AdMobilize - Reports',
    description: 'Generate and view reports.',
    noIndex: true
  },
  '/integrations': {
    title: 'AdMobilize - Integrations',
    description: 'Manage your integrations and connections.',
    noIndex: true
  },
  '/sitegroups': {
    title: 'AdMobilize - Site Groups',
    description: 'Organize your sites into groups.',
    noIndex: true
  },
  '/advanced': {
    title: 'AdMobilize - Advanced Settings',
    description: 'Configure advanced settings for your account.',
    noIndex: true
  },
  '/presets': {
    title: 'AdMobilize - Presets',
    description: 'Manage your preset configurations.',
    noIndex: true
  },
  '/profile': {
    title: 'AdMobilize - Profile',
    description: 'View and edit your user profile.',
    noIndex: true
  },
  '/users': {
    title: 'AdMobilize - Users',
    description: 'Manage user accounts and permissions.',
    noIndex: true
  },
  '/campaigns': {
    title: 'AdMobilize - Brands',
    description: 'Manage your advertising campaigns.',
    noIndex: true
  },
  '/portals': {
    title: 'AdMobilize - Portals',
    description: 'Manage your campaigns portals.',
    noIndex: true
  }
};
